import FilterSelect from "../../components/FilterSelect/FilterSelect";
import {HISTORY_TYPE, HISTORY_RESULT, HISTORY_FILTER_INITIAL_STATE} from "../../../../../constants/index.jsx";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import FilterInput from "../../components/FilterInput/FilterInput";
import {setHistoryFilter} from "../../../../../redux/actions/history/actions";
function DesktopHistoryFilter() {
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const filter = useSelector(state => state.history.filter);
    const {
        minBet,
        stepTimes,
        tillValues,
        bankTimes,
        gameConventions
    } = useSelector(state => state.user.config);
    const mapTranslatedOptions = (options, translateLabel = '') => {
        return options.map((option) => {
            return {...option, label: t(`${translateLabel}.${option.label}`)}
        })
    }
    const handleChange = (data) => {
        dispatch(setHistoryFilter(data))
    }

    const resetChanges = () => {
        dispatch(setHistoryFilter(HISTORY_FILTER_INITIAL_STATE));
    }

    return <div className="history-filter">
        <div className="history-filter__left">
            <FilterSelect
                data={mapTranslatedOptions(HISTORY_TYPE, "filter")}
                placeholder={t("filter.history_type")}
                handleChange={handleChange}
                name="type"
                value={filter?.type}
            />
            <FilterSelect
                data={mapTranslatedOptions(HISTORY_RESULT, "filter")}
                placeholder={t("filter.history_result")}
                handleChange={handleChange}
                name="result"
                value={filter?.result}
            />
            <FilterSelect
                data={[{value: 'all', label: t('filter.all')}, ...tillValues]}
                placeholder={t("filter.history_till")}
                handleChange={handleChange}
                name="till"
                value={filter?.till}
            />
        </div>
        <div className="history-filter__right">
            <span className="filterBet">{t("filter.bet")}</span>
            <FilterInput
                placeholder={t("filter.min_bet")}
                handleChange={handleChange}
                name="minBet"
                value={filter.minBet}
            />
            <FilterInput
                placeholder={t("filter.max_bet")}
                handleChange={handleChange}
                name="maxBet"
                value={filter.maxBet}
            />
        </div>
        <i
            className="delete-filters icon-bin1"
            title={t("filter.clear_all")}
            onClick={() => resetChanges()}
        />
    </div>
}

export default DesktopHistoryFilter;